"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IChargeMethod_1 = require("../../../models/rates/IChargeMethod");
exports.default = joi_1.default.object({
    chargeType: joi_1.default.string()
        .valid(IChargeMethod_1.ChargeType.Flat /* , ChargeType.Percentage */)
        .required(),
    countingUnit: joi_1.default.string()
        .valid(IChargeMethod_1.CountingUnit.ShortTon, IChargeMethod_1.CountingUnit.Transaction, 
    // CountingUnit.Carriers,
    IChargeMethod_1.CountingUnit.LineItems, IChargeMethod_1.CountingUnit.HundredWeight, IChargeMethod_1.CountingUnit.PrimaryUnits, IChargeMethod_1.CountingUnit.SecondaryUnits, IChargeMethod_1.CountingUnit.PackagingUnits, IChargeMethod_1.CountingUnit.MoveableUnits, IChargeMethod_1.CountingUnit.Lot, IChargeMethod_1.CountingUnit.Location, IChargeMethod_1.CountingUnit.ItemClass, IChargeMethod_1.CountingUnit.SKU, IChargeMethod_1.CountingUnit.TotalPackages, IChargeMethod_1.CountingUnit.TotalMUs, IChargeMethod_1.CountingUnit.UniqueMULabels)
        .id(IChargeMethod_1.ChargeType.Flat)
        .required(),
    calculatedBy: joi_1.default.when('countingUnit', [
        /* { is: CountingUnit.Shipping, then: Joi.string().valid(CalculatedBy.ChargeTotal).id(CountingUnit.Shipping) },
        { is: CountingUnit.FulfillmentInvoicing, then: Joi.string().valid(CalculatedBy.ChargeTotal).id(CountingUnit.FulfillmentInvoicing) }, */
        {
            is: IChargeMethod_1.CountingUnit.ShortTon,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.ShortTon),
        },
        {
            is: IChargeMethod_1.CountingUnit.Transaction,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.Transaction),
        },
        /* { is: CountingUnit.Carriers, then: Joi.string().valid(CalculatedBy.Count).id(CountingUnit.Carriers) }, */
        {
            is: IChargeMethod_1.CountingUnit.LineItems,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.LineItems),
        },
        {
            is: IChargeMethod_1.CountingUnit.HundredWeight,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.HundredWeight),
        },
        {
            is: IChargeMethod_1.CountingUnit.PrimaryUnits,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.CountLessOtherUoms, IChargeMethod_1.CalculatedBy.Weight, 
            // CalculatedBy.Area,
            IChargeMethod_1.CalculatedBy.Volume)
                .id(IChargeMethod_1.CountingUnit.PrimaryUnits),
        },
        {
            is: IChargeMethod_1.CountingUnit.SecondaryUnits,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.CountLessOtherUoms, IChargeMethod_1.CalculatedBy.Weight, 
            // CalculatedBy.Area,
            IChargeMethod_1.CalculatedBy.Volume)
                .id(IChargeMethod_1.CountingUnit.SecondaryUnits),
        },
        {
            is: IChargeMethod_1.CountingUnit.PackagingUnits,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.CountLessOtherUoms, IChargeMethod_1.CalculatedBy.Weight, 
            // CalculatedBy.Area,
            IChargeMethod_1.CalculatedBy.Volume)
                .id(IChargeMethod_1.CountingUnit.PackagingUnits),
        },
        {
            is: IChargeMethod_1.CountingUnit.MoveableUnits,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.CountLessOtherUoms, IChargeMethod_1.CalculatedBy.Weight, 
            // CalculatedBy.Area,
            IChargeMethod_1.CalculatedBy.Volume)
                .id(IChargeMethod_1.CountingUnit.MoveableUnits),
        },
        {
            is: IChargeMethod_1.CountingUnit.Lot,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.HundredWeight, IChargeMethod_1.CalculatedBy.ShortTon)
                .id(IChargeMethod_1.CountingUnit.Lot),
        },
        {
            is: IChargeMethod_1.CountingUnit.Location,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.Location),
        },
        {
            is: IChargeMethod_1.CountingUnit.ItemClass,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.HundredWeight, IChargeMethod_1.CalculatedBy.ShortTon)
                .id(IChargeMethod_1.CountingUnit.ItemClass),
        },
        {
            is: IChargeMethod_1.CountingUnit.SKU,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.HundredWeight, IChargeMethod_1.CalculatedBy.ShortTon)
                .id(IChargeMethod_1.CountingUnit.SKU),
        },
        {
            is: IChargeMethod_1.CountingUnit.TotalPackages,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.Weight)
                .id(IChargeMethod_1.CountingUnit.TotalPackages),
        },
        {
            is: IChargeMethod_1.CountingUnit.TotalMUs,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.Volume)
                .id(IChargeMethod_1.CountingUnit.TotalMUs),
        },
        {
            is: IChargeMethod_1.CountingUnit.UniqueMULabels,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count, IChargeMethod_1.CalculatedBy.AreaSqFt, IChargeMethod_1.CalculatedBy.AreaSqM)
                .id(IChargeMethod_1.CountingUnit.UniqueMULabels),
        },
    ]).required(),
    roundUp: joi_1.default.boolean().optional(),
}).id('shipping');
